export default {
  form: {
    agreement: {
      label:
        'Riconosco che fornire la mia approvazione elettronica equivale a firmare questo documento e comprendo che la mia firma elettronica è vincolante.',
    },
    signed_by: {
      label: 'Nome',
      placeholder: 'Nome',
    },
    signer_first_name: {
      label: 'Nome',
      placeholder: 'Nome',
    },
    signer_last_name: {
      label: 'Cognome',
      placeholder: 'Cognome',
    },
    recipient_email: {
      label: 'Indirizzo email del destinatario',
      placeholder: "Inserisci l'indirizzo email",
    },
    send_to_email: {
      label: 'Invia il contratto al titolare via email ({{email}})',
    },
    additional_locations: {
      label: 'Sedi aggiuntive',
      placeholder: 'Cerca una sede da aggiungere',
    },
    special_agreements: {
      label: 'Accordi speciali',
      placeholder: 'Inserisci eventuali accordi speciali',
    },
  },
  labels: {
    name: 'Nome',
    date: 'Data',
  },
  buttons: {
    sign_in_person: 'Firma qui con il titolare',
    back: 'Indietro',
    edit_contract: 'Modifica contratto',
    skip: 'Salta',
    sign: 'Firma',
    init_sign: 'Crea contratto e invia',
    redo: 'Ripristina',
    continue: 'Continua',
    preview: 'Anteprima',
    submit: 'Invia',
  },
  toasts: {
    failed_to_preview_contract: "Impossibile visualizzare l'anteprima del contratto",
    contract_signing_pending: 'Attendi, stiamo avviando il tuo contratto...',
    failed_to_sign_contract: 'Impossibile avviare il contratto ⁉️',
    contract_got_signed: 'Contratto avviato 👌',
  },
  in_person_signing: {
    description:
      'Il titolare ha ricevuto questo link via email e può firmare da remoto. Se il titolare è con te in questo momento, apri qui la pagina di firma.',
  },
  signature_link: {
    label: 'Link di firma (stesso link inviato al destinatario via email)',
    copy: 'Copia',
    copied: 'Link di firma copiato negli appunti',
  },
  header: 'Crea contratto',
  description: "Rivedi i dettagli del contratto e inserisci l'indirizzo email a cui inviarlo.",
};
